module.exports = __webpack_public_path__ + "img/dropdown-arrow-white.3ecd8f09.svg";